<div class="modal-header">
	<h3 class="modal-title" id="modal-title-id">
		<span>{{LOCALIZATION.geotag}}</span>
	</h3>
</div>
<div class="modal-body d-flex flex-column" style="height: 70vh;">
	<div class="main-toolbar" style="padding-bottom: 15px;">
    	<button id="geotagmap" class="btn btn-default btn-md" (click)="mode = 'map'">{{LOCALIZATION.geotagMap}}</button>
    	<button id="geotaglocation" class="btn btn-default btn-md" (click)="mode = 'location'">{{LOCALIZATION.geotagLocation}}</button>
    	<button id="geotagentity" *ngIf="isEntitiesExtraction" class="btn btn-default btn-md" (click)="mode = 'entity'">{{LOCALIZATION.geotagEntity}}</button>	
	</div>
    <div [hidden]="mode !== 'map'">
        <div style="height: 60vh">
            <div id="esri-map-container" style="position: relative;">
                <div id="mapToolbar">
                    <form class="navbar-form " style="display:inline-block; padding:0px 0px;">
                        <div class="dropdown" ngbDropdown>
                            <button id="basemap-menu-button" class="btn btn-default dropdown-toggle" ngbDropdownToggle title="Select a base layer" attr-label="Select a base layer">
                                <i class="fas fa-layer-group"></i>
                            </button>
                            <ul class="dropdown-menu custom-drop" ngbDropdownMenu aria-labelledby="basemap-menu-button" role="menu">
                                <li class="pointMe" *ngFor="let basemap of basemapConfigs" (click)="changeBasemap(basemap.name)">
                                	<a style="color: #26a69a;">{{basemap.displayName}}</a>
                                </li>
                            </ul>
                        </div>
                    </form>
                    <form class="navbar-form" style="display:inline-block; padding:0px 0px;">
                        <button class="btn btn-default dropdown-toggle" title="{{LOCALIZATION.deleteItem}}" (click)="clearMap()">
                            <i class="fas fa-trash"></i>
                        </button>
                    </form>
                    <form class="navbar-form" style="display:inline-block; padding:0px 0px;">
                        <div class="dropdown" ngbDropdown>
                            <button id="search-coordinates-menu-button" class="btn btn-default dropdown-toggle" ngbDropdownToggle title="{{LOCALIZATION.searchCoordinates}}" [attr.aria-label]="LOCALIZATION.searchCoordinates">
                                <i class="fa fa-search"></i>
                            </button>
                            <div class="dropdown-menu map-search" ngbDropdownMenu aria-labelledby="search-coordinates-menu-button" role="menu" style="height:auto; padding:10px;">
                                <div class="row">
                                    <div class="text-center"><span class="text-bold">{{LOCALIZATION.searchCoordinates}}</span></div>
                                    <br>
                                    <div class="col-md-5">
                                        <div class="input-group">
                                            <div class="input-group-addon">{{LOCALIZATION.longitude}}</div>
                                            <input type="number" class="form-control" [(ngModel)]="search.x" name="longitude" aria-label="Longitude" />
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="input-group">
                                            <div class="input-group-addon">{{LOCALIZATION.latitude}}</div>
                                            <input type="number" class="form-control" [(ngModel)]="search.y" name="latitude" aria-label="Latitude" />
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <button class="btn btn-default btn-md pull-right" (click)="zoomTo()"><i class="fa fa-search"></i></button>
                                    </div>
                                </div>
                                <hr>
                                <div class="text-center"><span class="text-bold">{{LOCALIZATION.searchGazeteer}}</span></div>
                                <br>
                                <div class="row">
                                    <div id="locationHolder" class="col-xs-12"><div id="geotagLocationBar"></div></div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div id='fullExtentButton' class="esriSimpleSlider esriSimpleSliderVertical esriSimpleSliderTL" style="z-index: 30;">
                    <div title="{{LOCALIZATION.zoomFull}}" (click)='fullExtent()'>
                        <i class="fas fa-globe-americas"></i>
                    </div>
                </div>
                <div id='drawButtons' class="hidden-xs esriSimpleSlider esriSimpleSliderVertical esriSimpleSliderTL" style="z-index: 30;">
                    <div class="esriSimpleSliderIncrementButton" title="{{LOCALIZATION.byRectangle}}" (click)='activeShape("rectangle")'>
                        <i class="far fa-square" [ngClass]="{'shapeInactive' : tools.activeShape !== 'rectangle', 'shapeActive' : tools.activeShape === 'rectangle'}"></i>
                    </div>
                    <div class="esriSimpleSliderIncrementButton" title="{{LOCALIZATION.byPolygon}}" (click)='activeShape("polygon")'>
                        <i class="fa fa-draw-polygon" [ngClass]="{'shapeInactive' : tools.activeShape !== 'polygon', 'shapeActive' : tools.activeShape === 'polygon'}"> </i>
                    </div>
                    <div class="esriSimpleSliderIncrementButton" title="{{LOCALIZATION.byCircle}}" (click)='activeShape("circle")'>
                        <i class="far fa-circle" [ngClass]="{'shapeInactive' : tools.activeShape !== 'circle', 'shapeActive' : tools.activeShape === 'circle'}"> </i>
                    </div>
                    <div class="esriSimpleSliderIncrementButton" title="{{LOCALIZATION.byPoint}}" (click)='activeShape("point")'>
                        <i class="fa fa-map-marker-alt" [ngClass]="{'shapeInactive' : tools.activeShape !== 'point', 'shapeActive' : tools.activeShape === 'point'}"></i>
                    </div>
                </div>

  				<div #mapContainer id='mapViewDiv' class="flex-grow-1 w-100" style="height:100%; margin:0; padding:0;"></div>
  
            </div>
        </div>
    </div>
    <div [hidden]="mode !== 'location'">
    	<div class="locations-toolbar">
	        <button class="btn btn-md btn-primary" (click)="importLocations()">{{LOCALIZATION.import}}</button>
	        <button class="btn btn-md btn-primary" (click)="loadSavedLocations()">{{LOCALIZATION.refresh}}</button>
        </div>
        <div *ngIf="mylocations && mylocations.length > 0">
            <div style="max-height:400px; overflow-y:auto;">
                <div *ngFor='let location of mylocations' 
                	(click)="selectLocation(location)" 
                	class="item-hover pointMe panel-body" 
                	[ngClass]="{'item-selected' : selected?.id === location.id}">
                    <div class="col-xs-4">
						<p class='dd-text-collapse' 
							ddTextCollapse
							[ddTextCollapseMaxLength]="100" 
							[ddTextCollapseText]="location.name">
						</p>
                    </div>
                    <div class="col-xs-8">
						<p class='dd-text-collapse' 
							ddTextCollapse
							[ddTextCollapseMaxLength]="100" 
							[ddTextCollapseText]="location.geo">
						</p>
                    </div>
                </div>
            </div>
            <div class="text-center">
					  <ngb-pagination class="pagination custom-page pagination-sm"
					    [(page)]="pagination.page" 
					    [pageSize]="pagination.elementsPerPage"
					    [collectionSize]="pagination.totalElements" 
					    (pageChange)="pagination.pageChanged($event)"
					    [maxSize]="5"
					    [boundaryLinks]="true"
					    previousText="&#xf053;"
					    nextText="&#xf054;"
					    firstText="&#xf053;&#xf053;"
					    lastText="&#xf054;&#xf054;">
					  </ngb-pagination>
            </div>
        </div>
        <div *ngIf="mylocations && mylocations.length === 0">
            <em>{{LOCALIZATION.savedLocations}}</em>
        </div>
    </div>
    <div [hidden]="mode !== 'entity'">
    	<div>
 			<div class="form-group">
			  <div class="checkbox">
			    <label for="geotagExtractPlaces">
					<input id="geotagExtractPlaces" name="isPlaces" [(ngModel)]="extractOpts.isPlaces" type="checkbox" checked />
            		{{LOCALIZATION.geotagExtractPlaces}} 
			    </label>
			    <div class="help-block">Extracts places from the document file.</div>
			  </div> 
			  <div class="checkbox">
			    <label for="geotagExtractCoordinates">
					<input id="geotagExtractCoordinates" name="isCoordinates" [(ngModel)]="extractOpts.isCoordinates" type="checkbox" />
            		{{LOCALIZATION.geotagExtractCoordinates}}
			    </label>
			    <div class="help-block">Extracts coordinates from the document file.</div>
			  </div>
			  <div class="checkbox">
			    <label for="geotagExtractCountries">
					<input id="geotagExtractCountries" name="isCountries" [(ngModel)]="extractOpts.isCountries" type="checkbox" />
            		 {{LOCALIZATION.geotagExtractCountries}}
			    </label>
			    <div class="help-block">Extracts countries from the document file.</div>
			  </div>
        	</div>
        </div>
        <button class="btn btn-primary" [disabled]="inprogress" (click)="extractTag()">{{LOCALIZATION.geotagExtract}}</button>
    </div>
    <div *ngIf="mode === 'entity' && geotagEntities && geotagEntities.length > 0">
        <div style="max-height:400px; overflow-y:auto;">
            <div *ngFor='let location of geotagEntities'
            	(click)="selectEntity(location)"
            	class="item-hover pointMe panel-body" 
            	[ngClass]="{'item-selected' : isSelectedEntity(location)}">
                <div class="col-xs-7">
					<p *ngIf="location.name"
						class='dd-text-collapse' 
						ddTextCollapse
						[ddTextCollapseMaxLength]="100" 
						[ddTextCollapseText]="location.name">
					</p>
					<p *ngIf="!location.name"
						class='dd-text-collapse' 
						ddTextCollapse
						[ddTextCollapseMaxLength]="100" 
						[ddTextCollapseText]="(location.related_place_name + location['province-name'] + location.cc)">
					</p>
                </div>
                <div class="col-xs-3">
					<p class='dd-text-collapse' 
						ddTextCollapse
						[ddTextCollapseMaxLength]="100" 
						[ddTextCollapseText]="(location.lon + location.lat)">
					</p>
                </div>
                <div class="col-xs-2">
					<p class='dd-text-collapse' 
						ddTextCollapse
						[ddTextCollapseMaxLength]="100" 
						[ddTextCollapseText]="location.confidence">
					</p>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <div class="help-block pull-left col-xs-12" *ngIf="!selected && selectedEntities.length === 0">Add a shape on the map or select a location to continue.</div>
    <div class="col-xs-12">
    	<button class="btn btn-default" (click)="close()">{{LOCALIZATION.cancel}}</button>
	    <button class="btn btn-primary" [disabled]="(!selected && selectedEntities.length === 0) || inprogress" (click)="tag()">
	        <i class="fas fa-spinner fa-spin fa-fw" *ngIf="inprogress"></i>
	        {{LOCALIZATION.geotag}}
	    </button>
    </div>
</div>
